import { JSX } from 'react'
import withErrorBoundary from '@/Routes/pages/utils/withErrorBoundary/withErrorBoundary'
import withLoadedNotify from '@/Routes/pages/utils/withLoadedNotify/withLoadedNotify'
import ErrorPage from '@/components/ErrorBoundary/FC/ErrorPage/ErrorPage'

const catchImportComponentError = (func: () => Promise<{ default: (props: any) => JSX.Element }>)  => {
  return async() => {
    try {
      return await func()
    } catch (e) {
      return { default: withErrorBoundary(withLoadedNotify(ErrorPage)) }
    }
  }
}

export default catchImportComponentError
